// ! ||--------------------------------------------------------------------------------||
// ! ||                                   PDP Offers                                   ||
// ! ||--------------------------------------------------------------------------------||
class ExtendProductOffer extends HTMLElement {
  constructor(productForm, addToCartButton) {
    super();

    const referenceId = productForm.id.value;
    const price = meta.product.variants.filter(
      (variant) => variant.id == referenceId,
    )[0].price;
    const category = meta.product.type;

    this.params = {
      referenceId,
      price,
      category,
    };

    this.config = getConfiguration();
    this.config.dispatchSideCart = false;

    this.productForm = productForm;
    this.addToCartButton = addToCartButton;
  }

  connectedCallback() {
    try {
      this.verifyProductOffer();
    } catch (err) {
      console.error(err.message);
      return;
    }

    this.bindEvents();
    this.style.display = "block";

    if (!this.config.pdpOfferEnabled) this.style.display = "none";
    // Renders Extend offer
    Extend.buttons.render(this, this.params, () => {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 250);
    });
  }

  bindEvents() {
    this.handleAddToCart = this.handleAddToCart.bind(this);

    document.addEventListener("click", this.handleAddToCart, true);
    this.productForm.addEventListener(
      "change",
      this.handleVariantChange.bind(this),
      true,
    );
  }

  verifyProductOffer() {
    let elementsToCheck = [
      "this.productForm",
      "this.addToCartButton",
      "this.params.referenceId",
      "this.params.price",
      "this.params.category",
    ];

    let missingElements = elementsToCheck.filter((value) => {
      try {
        return !eval(value);
      } catch (err) {
        return true;
      }
    });

    if (missingElements.length) {
      let message = "The following value(s) are null or undefined:\n";
      missingElements.forEach((value) => {
        message += `\t${value}\n`;
      });
      throw new ExtendError(message);
    }

    // Checks if Extend lives in the window and the active currency is USD before showing Extend offers
    verifyExtend();
  }

  modalDone() {
    // remove default click listener
    document.removeEventListener("click", this.handleAddToCart, true);
    // click atc button
    this.addToCartButton.click();
    // add default click listener back
    document.addEventListener("click", this.handleAddToCart, true);
  }

  /**
   * Handle add to cart event with offers
   * @param {PointerEvent} e Click event from Add To Cart Button
   */
  handleAddToCart(e) {
    if (![e.target.parentElement, e.target].includes(this.addToCartButton))
      return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const quantityEl = this.productForm.querySelector('[name="quantity"]');
    const quantity = quantityEl && quantityEl.value ? quantityEl.value : 1;

    ExtendShopify.handleAddToCart(this, {
      quantity: quantity,
      modal: this.config.offerModalEnabled,
      done: this.modalDone.bind(this),
    });
  }

  handleVariantChange() {
    this.params.referenceId = this.productForm.id.value;
    this.params.price = meta.product.variants.filter(
      (variant) => variant.id == this.params.referenceId,
    )[0].price;

    Extend.setActiveProduct(this, this.params);
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 250);
  }
}
if (!customElements.get("extend-offer"))
  customElements.define("extend-offer", ExtendProductOffer);

/**
 * Initializes product offers and handles ATC button functionality for the main PDP ATC
 */
function initProductOffer() {
  try {
    if (meta.page.pageType != "product" || !meta.product)
      throw new ExtendError(
        "Extend Product Offer - The current page is not a product page",
      );
  } catch (err) {
    console.warn(err.message);
    return;
  }

  const productFormSelector = 'product-form form[action="/cart/add"]';
  const addToCartButtonSelector = 'button[name="add"]';

  const productForm = document.querySelector(productFormSelector);
  const addToCartButton = productForm
    ? productForm.querySelector(addToCartButtonSelector)
    : document.querySelector(addToCartButtonSelector);
  // Create offer and render it
  const extendOffer = new ExtendProductOffer(productForm, addToCartButton);

  productForm.before(extendOffer);
}

// ! ||--------------------------------------------------------------------------------||
// ! ||                                   Cart Offers                                  ||
// ! ||--------------------------------------------------------------------------------||

const cartOfferTag = "extend-cart-offer";

class ExtendCartOffer extends HTMLElement {
  constructor(referenceId, category, price, quantity, type) {
    super();
    this.params = {
      referenceId,
      category,
      price,
      quantity,
    };
    this.type = type;

    this.config = getConfiguration();
  }

  connectedCallback() {
    if (!this.canDisplayOffer()) {
      return;
    }

    Extend.buttons.renderSimpleOffer(this, {
      ...this.params,
      onAddToCart: ({ plan, product }) => {
        ExtendShopify.addPlanToCart(
          {
            plan,
            product,
            quantity: this.params.quantity,
          },
          (err) => {
            if (err) {
              throw new ExtendError(err.message);
            }

            document.dispatchEvent(
              new CustomEvent("extend.plan-update", {
                detail: { offer: this },
              }),
            );
          },
        );
      },
    });
  }

  canDisplayOffer() {
    return (
      (this.type === "main" && this.config.cartOfferEnabled) ||
      (this.type === "side" && this.config.sideCartOfferEnabled)
    );
  }
}
if (!customElements.get(cartOfferTag))
  customElements.define(cartOfferTag, ExtendCartOffer);

const initCartOffer = (() => {
  var cart;
  var init = false;

  const {
    cartOfferEnabled,
    cartSPEnabled,
    sideCartOfferEnabled,
    cartBalancingEnabled,
    SPEnabled,
  } = getConfiguration();

  let type, selectors;
  if (meta.page.pageType === "cart" && (cartOfferEnabled || cartSPEnabled)) {
    selectors = {
      cartContainer: "cart-items",
      cartRowItem: ".cart-item", // Container element for each item in the cart
      cartRowItemImage: ".cart-item__link", // Product image or image anchor element
      cartRowItemTitle: ".cart-item__name", // Title anchor element for the product
      cartRowItemQuantity: 'input[name="updates[]"]', // Input element containing the product quantity
      warrantyOriginalMeta: ".product-option", // Each warranty metadata item we want to remove.
      offerAnchor: ".cart-item__details", // Container where the offer will be appended
      metadataContainer: "dl", // Where warranty metadata will be appended (Product and Term)
      quantityWrapper: "quantity-input", // Wrapper for quantity input and buttons
    };
    type = "main";
  } else if (sideCartOfferEnabled) {
    selectors = {
      cartContainer: "cart-drawer-items",
      cartRowItem: "table.cart-items tbody tr",
      cartRowItemImage: ".cart-item__media", // Product image or image anchor element
      cartRowItemTitle: ".cart-item__name", // Title anchor element for the product
      cartRowItemQuantity: 'input[name="updates[]"]', // Input element containing the product quantity
      warrantyOriginalMeta: ".product-option", // Each warranty metadata item we want to remove.
      offerAnchor: ".cart-item__details", // Container where the offer will be appended
      metadataContainer: "dl", // Where warranty metadata will be appended (Product and Term)
      quantityWrapper: "quantity-input", // Wrapper for quantity input and buttons
      lineItemRemove: "",
    };
    type = "side";
  }

  if (type === undefined || selectors === undefined) {
    throw new ExtendError("No cart type detected");
  }
  function createWarrantyOffer(lineItemElement, index) {
    if (!cartOfferEnabled) return;
    
    const anchor = lineItemElement.querySelector(selectors.offerAnchor);
    if (!anchor) {
      throw new ExtendError(
        `Offer anchor element on line ${index} not found with selector ${selectors.offerAnchor}`,
      );
    }

    const container = anchor.querySelector('div[extend-bundle-offer]');

    const cartItem = cart.items[index];
    const referenceId = container ? container.dataset.referenceId : cartItem.variant_id;
    const quantity =  container ? container.dataset.quantity :cartItem.quantity;
    const price = container ? container.dataset.price : cartItem.price;
    const category = container ? container.dataset.category : cartItem.product_type;
    const warrantyAlreadyInCart =
      ExtendShopify.warrantyAlreadyInCart(referenceId, cart.items) ||
      ExtendShopify.warrantyAlreadyInCart(referenceId.toString(), cart.items);

    const extendOffer = lineItemElement.querySelector(cartOfferTag);

    // If there's already an offer element, check that the properties match what we are trying to create
    // If they do not match, or the warranty is already in cart, remove the offer
    if (extendOffer) {
      if (
        extendOffer.params.referenceId !== referenceId ||
        extendOffer.params.quantity !== quantity ||
        extendOffer.params.price !== price ||
        extendOffer.params.category !== category ||
        warrantyAlreadyInCart
      ) {
        extendOffer.remove();
        // If they do match and the warranty is not already in the cart, do not create a new offer
      } else {
        return;
      }
      // If there is no offer element, but the warranty is already in cart, do not create a new offer
    } else if (warrantyAlreadyInCart) {
      return;
    }

    const newExtendOffer = new ExtendCartOffer(
          referenceId,
          category,
          price,
          quantity,
          type,
        );

    anchor.append(newExtendOffer); // append, prepend, after, before 
  }

  function styleWarrantyLineItem(lineItemElement, index) {
    const title = lineItemElement.querySelector(selectors.cartRowItemTitle);
    title.style.pointerEvents = "none";
    title.innerText = "Extend Protection Plan";

    const image = lineItemElement.querySelector(selectors.cartRowItemImage);

    if (image) {
      image.style.pointerEvents = "none";
    } else {
      console.error(
        `EXTEND: Line item image element on line ${index} not found with selector ${selectors.cartRowItemImage}`,
      );
    }

    const warrantyMetadata = lineItemElement.querySelectorAll(
      selectors.warrantyOriginalMeta,
    );

    if (warrantyMetadata?.length) {
      warrantyMetadata.forEach((each) => {
        const property = each.innerHTML.replaceAll(
          / |\t|\n|(<(\/){0,1}\w+>)/g,
          "",
        );
        if (!property.includes("Product:") && !property.includes("Term:"))
          each.remove();
        else {
          each.classList.add("extend-warranty-info");
          if (property.endsWith("Covered Product")) {
            const productId = cart.items[index].properties["_Extend.ProductId"];
            const productName = cart.items.filter((item) => {
              const id = item.id || item.variantId;
              return id.toString() == productId;
            })[0].title;
            each.innerHTML = each.innerHTML.replace(
              "Covered Product",
              productName,
            );
          }
        }
      });
    }

    if (
      selectors.quantityWrapper?.length &&
      lineItemElement.querySelector(selectors.quantityWrapper)
    ) {
      lineItemElement
        .querySelectorAll(selectors.quantityWrapper)
        .forEach((each) => {
          each.style.opacity = "75%";
          each.style.pointerEvents = "none";
        });
    }
  }

  function formatLineItems() {
    let cartContainer = document.querySelector(selectors.cartContainer);

    if (!cartContainer) {
      throw new ExtendError(
        `Invalid cart container selector: ${selectors.cartContainer}`,
      );
    }

    cartContainer
      .querySelectorAll(selectors.cartRowItem)
      .forEach((lineItemElement, index) => {
        let title = lineItemElement.querySelector(selectors.cartRowItemTitle);

        if (!title) {
          throw new ExtendError("Line item title not found");
        }

        let lowerCaseTitle = title.innerHTML.toLowerCase();

        if (lowerCaseTitle.includes("extend protection")) {
          styleWarrantyLineItem(lineItemElement, index);
        } else {
          createWarrantyOffer(lineItemElement, index);
        }
      });
  }

  function normalizeItems(callback) {
    getCart()
      .then((newCart) => {
        const bundleOffers = document.querySelector(selectors.cartContainer).querySelectorAll('div[extend-bundle-offer');
        bundleOffers.forEach(bundle => {
            newCart.items[bundle.dataset.cartIdx].variant_id = bundle.dataset.referenceId
        })
        return newCart;
      })
      .then((newCart) => {
        if (SPEnabled) {
          ExtendShopify.updateExtendLineItems({
            balanceCart: cartBalancingEnabled,
            isSPSupported: cartSPEnabled,
            callback,
          });
        } else {
          let normalizationOpts = {
            balance: cartBalancingEnabled,
            cart: newCart,
          };
          ExtendShopify.normalizeCart(normalizationOpts, callback);
        }
      });
  }

  function refreshCart() {
    if (type === "side") {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: "extend-cart" });
    } else if (type === "main") {
      location.reload();
    } else {
      window.location.reload();
    }
  }

  function verifyCartOffers() {
    verifyExtend();

    let error = "";
    if (!selectors) error = `Cart selectors are empty\n`;

    if (!type) error += `Cart type not defined\n`;

    if (error.length > 0) {
      throw new ExtendError(
        `Cannot initialize cart offers due to following errors:\n${error}`,
      );
    }
  }

  function initEventListeners() {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'extend-cart') return;
      onCartUpdate()
    });

    subscribe(PUB_SUB_EVENTS.cartRemove, (event) => {
      if (event.source === 'extend-cart') return;
      onCartUpdate()
    });

    subscribe(PUB_SUB_EVENTS.cartAdd, (event) => {
      if (event.source === 'extend-cart') return;
      onCartUpdate()
    });

    if (type === 'side' && !document.querySelector(selectors.cartContainer)) {
        document.addEventListener('cart-drawer-open', () => {
            onCartUpdate();
        }, {once: true});
    }

    document.addEventListener("extend.plan-update", refreshCart);

    init = true;
  }

  function onCartUpdate() {
    normalizeItems((err, data) => {
      cart = data.cart;
      if (err) {
        throw new ExtendError(err);
      }

      if (data?.updates) {
        refreshCart();
      }

      formatLineItems();
    });
  }

  return function initCartOffer() {
    verifyCartOffers();

    try {
      if (!/cart/.test(window.location.pathname) && !sideCartOfferEnabled) {
        throw new ExtendError(
          "Cannot initialize cart offers - not a cart page",
        );
      }
    } catch (err) {
      console.warn(err.message);
      return;
    }

    if (!init) initEventListeners();

    if (document.querySelector(selectors.cartContainer)) {
        onCartUpdate();
    }
  };
})();

// ! ||--------------------------------------------------------------------------------||
// ! ||                                      Utils                                     ||
// ! ||--------------------------------------------------------------------------------||
class ExtendError extends Error {
  constructor(message) {
    super(message);
  }
}

function getConfiguration() {
  return {
    currency: "USD",
    pdpOfferEnabled: true,
    offerModalEnabled: true,
    cartOfferEnabled: true,
    sideCartOfferEnabled: true,
    cartBalancingEnabled: true,
    aftermarketModalEnabled: true,
    atcOfferEnabled: true,
    quickviewOfferEnabled: true,
    quickviewModalOfferEnabled: true,
    cartSPEnabled: false,
    SPEnabled: false,
  };
}

function verifyExtend() {
  const propertiesToCheck = [
    "window.Extend",
    "window.ExtendShopify",
    "window.Shopify",
    "window.Shopify.currency.active",
  ];

  function checkPropertyExists(path) {
    return (
      path.split(".").reduce((obj, prop) => obj && obj[prop], window) !==
      undefined
    );
  }

  let errors = propertiesToCheck.filter((prop) => !checkPropertyExists(prop));

  // Check for currency mismatch
  if (window.Shopify?.currency?.active !== getConfiguration().currency) {
    errors.push("window.Shopify.currency.active == config.currency");
  }

  if (errors.length) {
    let message = "The following value(s) are null, undefined, or false:\n";
    errors.forEach((error) => {
      message += `\t${error}\n`;
    });
    throw new ExtendError(message);
  }
}

function initAftermarket() {
  try {
    verifyExtend();

    // Get params from URL
    const params = new URL(document.location).searchParams;

    // Check if leadToken or leadtoken is in the URL
    let leadToken = params.get("leadToken")
      ? params.get("leadToken")
      : params.get("leadtoken");

    if (leadToken) {
      Extend.aftermarketModal.open({
        leadToken: leadToken,
        onClose: function (plan, product, quantity) {
          if (plan && product) {
            ExtendShopify.addPlanToCart(
              {
                plan: plan,
                product: product,
                leadToken: leadToken,
                quantity: quantity || 1,
              },
              function () {
                location = "/cart";
              },
            );
          }
        },
      });
    }
  } catch (error) {
    throw new ExtendError(error.message);
  }
}

function getCart() {
  return fetch("/cart.js", {
    credentials: "same-origin",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  }).then((e) => e.json());
}

// Integration init
window.addEventListener("extend.integration", () => {
  try {
    // const storeId = "c7ff7a68-732d-451c-92c8-16a72e56f131";
    // const environment = "production";

    // window.Extend.config({ storeId, environment });

    const config = getConfiguration();

    if (config.aftermarketModalEnabled) initAftermarket();

    if (
      config.atcOfferEnabled ||
      config.offerModalEnabled ||
      config.pdpOfferEnabled
    )
      initProductOffer();

    if (
      config.cartOfferEnabled ||
      config.cartSPEnabled ||
      config.sideCartOfferEnabled
    )
      initCartOffer();
  } catch (err) {
    console.error(err);
  }
});
